import type { Messages } from '../messages.js'

/**
 * Danish. `træk` for flips, the word a Danish board game uses for a move — and one of several
 * here that does not change in the plural: et træk, to træk, like ord and point.
 */
export const da: Messages = {
  tag: 'da',

  readingDictionary: 'Læser ordbogen…',
  noWordList: 'Ingen ordliste til "{language}". Byg en:  pnpm dictionary build',
  emptyWordList: 'Ordlisten til "{language}" er tom.',

  flips: 'træk',
  score: 'point',
  words: 'ord',
  round: 'runde',
  ticksLeftLabel: 'Tid tilbage i denne runde',
  typeAWord: 'skriv et ord',
  tapPrompt: 'tryk på bogstaver for at vælge eller fortryde, derefter {action}',

  boardOfTiles: 'Bræt med {n} brikker',
  faceDown: 'vendt nedad',
  wildCard: 'joker',
  wildKey: 'et hvilket som helst bogstav',
  letterReplaced: '{from} blev til {to}',
  letterSwap: 'BOGSTAVBYTTE!',
  spentTile: 'brugt brik',
  hiddenWhilePaused: 'skjult under pause',
  letterInWord: '{letter}, bogstav {position} i ordet',

  completeWord: 'Færdiggør ord',

  completeShort: 'Færdig',
  reset: 'Ryd',
  pause: 'Pause',
  resume: 'Fortsæt',
  newGame: 'Nyt spil',
  paused: 'Pauset',
  outOfFlips: 'Ikke flere træk',
  finalResult: '{score} for {words} over {rounds}',
  playAgain: 'Spil igen',
  share: 'Del',
  shareCopied: 'Kopieret.',
  shareSelect: 'Kopiér dette:',

  lettersSelect: 'bogstaver vælger',
  keysWild: 'tages når du skriver et bogstav, ingen brik viser',
  clearsEvery: 'rydder alle valgte {letter}',
  undoLastLetter: 'fortryd sidste bogstav',
  noWordsYet: 'Ingen ord endnu.',

  wordRejected: '{word}  {reason}',
  reasonDuplicate: 'allerede fundet',
  reasonTooShort: 'for kort',
  reasonNotAWord: 'ikke et ord',
  reasonAllFound: 'du har dem alle',
  noSuchLetterUp: 'intet {letter} vendt',
  nothingUp: 'intet vendt',
  letterHidden: 'et bogstav skjulte sig',
  shuffled: 'blandet',
  shuffledAndBilled: 'blandet, trak {flips} ubrugte',
  tooFewLetters: 'For få bogstaver tilbage',

  gameLanguage: 'sprog',
  interfaceLanguage: 'grænseflade',
  dictionarySize: '{common} almindelige af {full} ord',
  filterLanguages: 'Søg efter sprog',
  noMatches: 'Ingen træffere',

  nerdMode: 'nørdetilstand',
  rules: 'Regler',
  difficulty: 'sværhedsgrad',
  difficultyNames: { easy: 'let', medium: 'mellem', hard: 'svær', insane: 'vanvittig' },
  pausedNoBoard: 'Dette spil kommer ikke på ranglisten.',
  about: 'Om',
  themeLabel: 'tema',
  themeNames: { traditional: 'traditionelt', light: 'lyst', contrast: 'høj kontrast' },
  tiles: 'brikker (N)',
  secondsPerTick: 'sekunder / tik',
  holdTicks: 'holdetik',
  minWord: 'korteste ord',
  startingFlips: 'træk ved start',
  wildChance: 'chance for joker',
  replaceChance: 'chance for bogstavbytte',
  hideChance: 'chance for at et bogstav skjules',
  wordCompleteMode: 'når ordet er færdigt',
  wordCompleteNames: { shuffle: 'bland', spend: 'brug', keep: 'behold' },
  flipEconomy: 'trækøkonomi',
  flipEconomyNames: {
    none: 'ingen',
    perLetter: 'per bogstav',
    fibonacci: 'fibonacci',
    overMinimum: 'over minimum',
  },
  repeatedLetterKey: 'tast for gentaget bogstav',
  keySchemeNames: { cycle: 'cyklus', advance: 'fremad' },
  keySchemeHelp: {
    cycle:
      'A tager det næste ubrugte A, og når de alle er i ordet, rydder det dem. ' +
      'Shift+A rydder dem også.',
    advance: 'A tager det næste ubrugte A. Shift+A rydder alle A i ordet.',
  },

  whatThatMeans: 'Hvad det betyder',
  factRound: 'runde',
  factWholeBoardUp: 'hele brættet vendt i',
  factRoundCosts: 'en runde koster',
  factFlipsBuy: 'starttræk køber',
  factThisBoard: 'dette bræt',
  factBoardHadToAdmit: 'brættet skulle tillade',
  ticksAndSeconds: '{ticks}, {seconds}',
  wordsLongest: '{words}, længste {longest}',
  wordsIncludingOneOf: '{words}, heraf et på {ceiling}',
  scorelessRounds: '{rounds} uden point',

  whatAWordPays: 'Hvad et ord giver',
  columnLetters: 'bogstaver',
  columnCost: 'pris',
  columnPoints: 'point',
  columnFlips: 'træk',
  columnNet: 'netto',

  canonicalRules: 'Almindelige regler for {difficulty}.',
  customRules: 'Ændret fra standarden. Point under egne regler kommer ikke på listen.',
  applyAndStart: 'Anvend og start et nyt spil',
  changesNextGame: 'Ændringerne gælder fra næste spil.',
  presets: 'Standarder:',

  start: 'Start',
  restart: 'Forfra',
  quit: 'Afslut',
  quitTitle: 'Afslutte dette spil?',
  restartTitle: 'Starte dette spil forfra?',
  restartConfirm: 'Forfra',
  quitConfirm: 'Afslut',
  keepPlaying: 'Spil videre',
  personalBest: 'Dine bedste spil',
  newPersonalBest: 'En ny personlig rekord.',
  columnRank: '#',
  notRanked: 'Egne regler, så dette spil kommer ikke på listen.',
  notRankedPaused: 'Uret stoppede, så dette spil kommer ikke på listen.',
  rankOfTotal: '{rank} af {total}',

  howToPlay: 'Sådan spiller du',

  backToGame: 'Tilbage til spillet',
  welcomeTitle: 'Velkommen til Blinkered',
  tutorialSkip: 'Spring over',
  tutorialNext: 'Næste',
  tutorialBack: 'Tilbage',
  tutorialStart: 'Begynd at spille',
  tutorialHideAgain: 'Vis ikke dette igen',
  tutorialProgress: '{n} af {total}',
  tutorialSkipTitle: 'Springe rundvisningen over?',
  tutGoalTitle: 'Blinkered er et kapløb',
  tutGoalBody:
    'Du starter spillet med et fast antal træk, og hver brik der vendes koster et træk. Når trækkene slipper op, er spillet forbi. Ord giver træk, og jo længere ordet er, jo flere træk får du.',
  tutSpentBody:
    'Bogstaver, du bruger i et ord, vendes med bagsiden op indtil næste runde. Kun et bogstavskift ændrer, hvilke bogstaver der er på brættet.',
  tutChangeTitle: 'Bogstaver kan ændre sig',
  tutSameLetters:
    'Så du et ord, du ikke nåede at spille? De samme bogstaver kommer igen i næste runde, blandet på nye pladser.',
  tutPickLetters: 'Tryk på de bogstaver du vil have, i rækkefølge, for at danne et ord.',
  tutMoreTurn:
    'Brikker bliver ved med at vende mens du tænker, så et bedre bogstav kan være på vej.',
  tutTapBack:
    'Kom du til at tage et forkert? Tryk på det igen for at give det tilbage. Et hvilket som helst, ikke kun det sidste.',
  tutComplete: 'Tryk på Færdig når ordet er klart.',
  htBoardTitle: 'Brættet',
  htBoardBody:
    'Brikkerne vendes én ad gangen, i tilfældig rækkefølge. Vendte brikker kan bruges til at danne ord.',
  htWordsTitle: 'Ordene',
  htWordsBody:
    'Dan et ord af de vendte brikker ved at skrive eller klikke bogstaverne i rækkefølge.',
  htFlipsTitle: 'Trækkene',
  htFlipsBody:
    'Hver brik der vendes koster et træk. Et færdigt ord giver træk tilbage, og længere ord giver flere. Når trækkene slipper op, er spillet forbi.',
  htRoundTitle: 'Runden',
  htRoundBody:
    'Når rundens sidste brik vendes, står hele brættet stille et øjeblik. Så vendes brikkerne om og blandes, og en ny runde begynder.',
  htLanguagesTitle: 'Sprogene',
  htLanguagesBody:
    '{n} af dem. Hvert bræt kan løses med ord folk faktisk bruger. Et usædvanligt ord giver også point, hvis ordbogen kender det.',
  htKeysTitle: 'Tastaturet',
  htWildTitle: 'Jokere',
  htWildBody:
    'Nogle gange dukker en joker op i stedet for et bogstav. En joker tæller som ethvert bogstav der danner et gyldigt ord. Et ord du allerede har fundet tæller ikke.',
  htHideTitle: 'Bogstaver der skjuler sig',
  htHideBody:
    'På de sværere niveauer kan et åbent bogstav vende sig om af sig selv og komme tilbage senere i runden. Timeren får et ekstra tik for det, i rødt. Bogstaver, du allerede har valgt, vender sig ikke om.',
  tutHideBody:
    'På de sværere niveauer kan et åbent bogstav vende sig om af sig selv og komme tilbage senere i runden. Bogstaver, du allerede har valgt, vender sig ikke om.',
  htSwapTitle: 'Bogstaver der skifter',
  htSwapBody:
    'Nogle gange bliver ét bogstav mellem runderne skiftet ud med et andet. Du får at se hvilket der forsvandt og hvilket der kom til.',
  htLevelsTitle: 'Niveauerne',
  htLevelEasy:
    'De samme tolv bogstaver hele spillet, så du kan lære dem og bære en liste af ord i hovedet. Brikkerne vendes langsomt, og hele brættet bliver stående længe nok til at gøre dit valg færdigt.',
  htLevelMedium:
    'Et bogstav skifter nu og da, så det bliver sværere at huske ord du har gemt til senere. Mindre tid til at kigge, og mindre til at tænke.',
  htLevelHard:
    'Ord på tre bogstaver tæller ikke længere, og et bogstav skifter omtrent hver anden runde. Brættet når knap at vise sig, før det blandes.',
  htLevelInsane:
    'Det hele på én gang, for fuld fart. Brættet blandes næsten lige efter sidste træk.',
  htTouchTitle: 'Berøringsskærmen',
  htTouchBody:
    'Tryk på en vendt brik for at tage dens bogstav. Tryk på et bogstav du har taget for at give det tilbage. Færdig og Ryd sidder under brættet.',

  accountTitle: 'Din konto',
  menuProfile: 'Min profil',
  menuGames: 'Mine spil',
  menuPublicPage: 'Min offentlige side',
  menuSignedInAs: 'Logget ind som',
  signIn: 'Log ind',
  signOut: 'Log ud',
  signInTitle: 'Log ind eller opret konto',
  signInLead: 'En konto gemmer dine spil, på alle de enheder du spiller på.',
  signInKeepGame: 'Log ind for at gemme dette spil, og alle de næste.',
  continueWithApple: 'Fortsæt med Apple',
  continueWithGoogle: 'Fortsæt med Google',
  signInOr: 'eller',
  emailLabel: 'E-mail',
  codeLabel: 'Kode',
  emailMeACode: 'Send mig en kode',
  working: 'Et øjeblik…',
  sendNewCode: 'Send en ny kode',
  codeSent: 'Se din mail. Koden gælder i 10 minutter.',
  notNow: 'Ikke nu',
  badEmail: 'Det ligner ikke en e-mailadresse.',
  badCode: 'Den kode virkede ikke. Koder udløber efter 10 minutter og gælder én gang.',
  serverBusy: 'Kunne ikke nå serveren. Prøv igen om lidt.',
  serverDown: 'Kunne ikke nå serveren.',
  offline: 'Offline',
  leaderboardTitle: 'Rangliste',
  leaderboardEmpty: 'Der er endnu ingen spil på denne rangliste. Bliv den første.',
  leaderboardWouldBe: 'Hvor dette spil ville stå',
  leaderboardThisGame: 'Dette spil',
  leaderboardRanksHere: 'Hvor dette spil står',
  leaderboardOutside: 'Uden for de fem bedste.',
  tutAccountTitle: 'Gem dine resultater',
  tutAccountBody:
    'En konto gemmer dine spil, sætter dine resultater på ranglisten og holder din profil.',
  ssoCancelled: 'Login blev afbrudt.',
  ssoExpired: 'Det tog for lang tid. Log ind igen.',
  ssoNoUsername: 'Kontoen kunne ikke gøres færdig. Prøv igen om lidt.',
  ssoFailed: 'Det virkede ikke. Prøv igen, eller brug din e-mail.',
  tabProfile: 'Profil',
  countryAny: 'Siger det ikke',
  findCountry: 'Søg lande',
  usernameLabel: 'Brugernavn',
  bioLabel: 'Om mig',
  countryLabel: 'Land',
  bioHint: 'Ingen links. {left}/{max}',
  save: 'Gem',
  saving: 'Gemmer…',
  saved: 'Gemt.',
  nameTaken: 'Nogen har allerede det navn.',
  nameTooShort: 'Lidt længere, tak.',
  nameTooLong: 'Det er for langt.',
  nameBadCharacters: 'Kun bogstaver, tal, bindestreger og understreger.',
  nameBadEdges: 'Det skal begynde og slutte med et bogstav eller et tal.',
  nameMixedScripts: 'Vælg ét alfabet og bliv i det.',
  nameReserved: 'Det ligner et navn, vi selv deler ud. Vælg et andet.',
  nameUnusable: 'Det navn kan ikke bruges.',
  bioTooLong: 'Om mig kan højst rumme {max} tegn.',
  bioHasLink: 'Links er ikke tilladt her.',
  bioHasControl: 'Det indeholder tegn, der ikke kan stå her.',
  bioUnusable: 'Den tekst kan ikke bruges.',
  gamesHeading: 'Spil',
  gamesEmpty: 'Her er ikke noget endnu. Spil, du spiller mens du er logget ind, dukker op her.',
  gamesEmptyShort: 'Her er ikke noget endnu.',
  gamesLoading: 'Læser dine spil…',
  theirGamesLoading: 'Læser deres spil…',
  profileLoading: 'Læser profilen…',
  playerNotFound: 'Der er ingen her med det navn.',
  columnWhen: 'Hvornår',
  columnRounds: 'runder',
  columnGame: 'Spil',
  gameLoading: 'Læser spillet…',
  gameUnreadable: 'Dette spil kunne ikke læses.',
  gameNotRanked: 'Spillet med ændrede regler, så det tæller ikke.',
  detailNotKept: 'Ordene og brættene for dette spil gemmes ikke længere.',
  openingBoard: 'Startbrættet',
  roundByRound: 'Runde for runde',
  roundNothing: 'intet fundet',
  changeReplaced: '{letter} erstattet på plads {slot}',
  changeWildOn: '{letter} joker på plads {slot}',
  changeWildOff: '{letter} joker væk fra plads {slot}',
  keepThisGame: 'Gem dette spil',
  savedToYourGames: 'Gemt blandt dine spil.',

  reportThis: 'Anmeld',
  reportHeading: 'Anmeld dette',
  reportTheName: 'Navnet',
  reportTheBio: 'Beskrivelsen',
  reportTheScore: 'Scoren',
  reportWhy: 'Hvad er der galt med det? Valgfrit.',
  reportSend: 'Send anmeldelsen',
  reportSent: 'Tak. Nogen ser på det.',
  reportSignIn: 'Log ind for at anmelde noget.',
  reportGone: 'Det er der ikke længere.',
  reportCancel: 'Annuller',

  deleteAccount: 'Slet min konto',
  deleteAccountWhat:
    'Det fjerner din profil og alle de spil, du har gemt, for altid. Det kan ikke gøres om.',
  deleteAccountAsk: 'Send mig en kode',
  deleteConfirm: 'Slet den for altid',
  deleteGone: 'Din konto er væk. Tak for spillet.',
  deleteNoAddress:
    'Der er ingen bekræftet adresse på denne konto, så en sletning kan ikke kontrolleres. Kontakt os, og vi gør det manuelt.',

  rulesetFacts: 'Ord på {letters} · en ny brik hvert {seconds}',
  plurals: {
    words: { one: '{n} ord', other: '{n} ord' },
    rounds: { one: '{n} runde', other: '{n} runder' },
    flips: { one: '{n} træk', other: '{n} træk' },
    ticks: { one: '{n} tik', other: '{n} tik' },
    points: { one: '{n} point', other: '{n} point' },
    minLetters: { one: 'mindst {n} bogstav', other: 'mindst {n} bogstaver' },
    seconds: { one: '{n} sekund', other: '{n} sekunder' },
  },
}
